<template>
  <div class="victim-map">
    <l-map
      :center="center"
      :zoom="zoom"
      :min-zoom="11"
      :max-zoom="16"
      :max-bounds="bounds"
      :options="{scrollWheelZoom:false}"
      ref="map">
      <l-tile-layer :url="url" :attribution="attribution" :options="{subdomains}"></l-tile-layer>
      <l-marker :lat-lng="marker"></l-marker>
    </l-map>
  </div>
</template>


<script>
import L from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
  name: "Victim",
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data() {
    return {
      zoom: 13,
      center: L.latLng(39.2891399125, -76.6165924072),
      bounds: L.latLngBounds([
        [39.151587, -76.930783],
        [39.509025, -76.259315]
      ]),
      url:
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}{r}.png",
      subdomains: "abcd",
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
    };
  },
  created() {
    let { lat, long } = JSON.parse(
      document.getElementById("victim-location").textContent
    );
    this.marker = L.latLng(lat, long);
    this.center = L.latLng(lat, long);
    this.zoom = 16;
  },
  methods: {},
  computed: {},
  watch: {}
};
</script>

<style lang="scss">
.victim-map {
  height: 100%;
  width: 100%;
}
</style>
